module.exports = __webpack_public_path__ + "img/balao_balao_5.797506d5.png";